import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import DailyVerse from "@/components/site/DailyVerse";
import About from "@/components/site/About";
import Schedule from "@/components/site/Schedule";
import UpcomingEvents from "@/components/site/UpcomingEvents";
import Ministries from "@/components/site/Ministries";
import Leadership from "@/components/site/Leadership";
import Testimonials from "@/components/site/Testimonials";
import Giving from "@/components/site/Giving";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-[#050505] text-white" data-testid="home-page">
      <Navbar />
      <Hero />
      <DailyVerse />
      <About />
      <Schedule />
      <UpcomingEvents />
      <Ministries />
      <Leadership />
      <Testimonials />
      <Giving />
      <Contact />
      <Footer />
    </main>
  );
}
